module.exports = __webpack_public_path__ + "img/HZ-A0212.d62be697.jpg";